import AddressStore from 'purchase/checkout/AddressManagement/addressStore';
import IdObserver from 'purchase/checkout/AddressManagement/IdObserver';
import ReadOnlyAddressObserver from 'purchase/checkout/AddressManagement/readOnlyAddressObserver';
import SelectObserver from 'purchase/checkout/AddressManagement/selectObserver';

class DeliveryAddressManager {
	constructor() {
		this.addressStore = AddressStore(window.od.deliveryAddress);
		this.selectObserver = new SelectObserver(
			this.addressStore,
			'savedDeliveryAddresses',
		);
		this.idObserver = new IdObserver(
			this.addressStore,
			'previouslySavedDeliveryAddress',
			'deliveryAddressReviewSectionReviewEditBtn',
		);
		this.readOnlyAddressObserver = new ReadOnlyAddressObserver(
			this.addressStore,
		);
	}
}

const canInitialise = () =>
	!!document.querySelector('[data-id="checkout-multi-delivery"]');

export { DeliveryAddressManager, canInitialise };
